import React from 'react'
import PropTypes from 'prop-types'
import Resx from '@/components/Resx'
import Icon from '@/components/Icon'
import { Button } from '@/components/button'

class ErrorViewer extends React.PureComponent {
  static propTypes = {
    onClick: PropTypes.func,
    error: PropTypes.object
  }
  render () {
    const { error, onClick } = this.props
    // const statusCode = error.response.status
    let msg = (error.response && error.response.data && error.response.data.error && error.response.data.error.message) || error.message
    if (!msg || msg === 'InternalServerError') {
      msg = 'Common.ServerInternalError'
    }
    if (error) {
      return (
        <div className='text-center'>
          <Button className='error' color='danger' onClick={onClick}>
            <Icon name='error' />
            <span><Resx name={msg} /></span>
          </Button>
        </div>
      )
    }
    return null
  }
}

export {
  ErrorViewer
}



// WEBPACK FOOTER //
// ./src/components/errorViewer.js